import { render, staticRenderFns } from "./DocNameAttributes.vue?vue&type=template&id=89023444&scoped=true&"
import script from "./DocNameAttributes.vue?vue&type=script&lang=js&"
export * from "./DocNameAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89023444",
  null
  
)

export default component.exports